module.exports = __webpack_public_path__ + "static/media/Multimedia Communication.6c535156.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ECE/Multimedia Communication.pdf
// module id = 121
// module chunks = 0